import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './configuration/setup/store';
import { config } from './config';
import { ensureUserIsLoggedIn } from './configuration/login';
import { getUserSessionHooks } from './configuration';
import { configureFetchDisplayMessages } from './configuration/lang/services';
import { getLanguageFromUrl, getThemeFromUrl } from './data/queryParamsUtils';

const prepareMocks = async () => {
    const isDev = import.meta.env.DEV;

    const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;
    if ((isDev && config.msw.enabled) || isProdPreview) {
        await import('../mocks/browser').then(({ startWorker }) => startWorker());
    }
};

const prepareRuntimeBasedOnQueryParams = async () => {
    // language
    const languageFromUrl = getLanguageFromUrl();
    if (languageFromUrl) {
        await configureFetchDisplayMessages(store)(languageFromUrl);
        console.log(`Language ${languageFromUrl} from URL parameter is used.`);
    }

    // theme
    const theme = getThemeFromUrl();
    if (theme) {
        document.documentElement.setAttribute('data-brand', theme);
    }
};

const renderApplication = async () => {
    // dynamically importing this so that the UIKIT will only start loading (and autoloading CSS) now.
    const { App } = await import('./App');
    createRoot(document.getElementById('root') as HTMLElement).render(
        <Provider store={store}>
            <App />
        </Provider>
    );
};

await prepareMocks();
await prepareRuntimeBasedOnQueryParams();
await ensureUserIsLoggedIn(renderApplication, getUserSessionHooks());
